import type { IconTypes } from '@ecomm/shared-icons'

export type MonitoringProps = {
  readonly title: string
  readonly description: readonly string[]
  readonly icons: readonly {
    readonly icon: IconTypes
    readonly text: string
  }[]
  readonly extraPriceText: string
  readonly productSKU: string
  readonly monthSubtitle: string
}

export const data: MonitoringProps = {
  icons: [
    {
      icon: 'ShieldCheck',
      text: 'Securitas guard response'
    },
    {
      icon: 'SecureHome',
      text: 'Whole home monitoring'
    },
    {
      icon: 'PoliceCar',
      text: 'Police response'
    },
    {
      icon: 'Fire',
      text: 'Fire response'
    },
    {
      icon: 'CameraRecording',
      text: 'Unlimited video recordings'
    },
    {
      icon: 'PhoneRinging',
      text: 'Instant alarm alerts on your phone'
    },
    {
      icon: 'Discount',
      text: '20% new hardware discount'
    },
    {
      icon: 'Contract',
      text: 'Premium Extended Warranty'
    }
  ],
  title: 'Pro Premium Monitoring',
  productSKU: 'SSEDSM2_GB__5229044',
  description: [
    '24/7 protection',
    'Unlimited camera recordings',
    'Highly trained agents that act quickly in an emergency',
    'Fast police response and guard dispatch'
  ],
  extraPriceText:
    'First month is free, no contract, cancel any time. After trial, monitoring is charged separately for {{price_per_day}} ({{price_per_month}})**',
  monthSubtitle: 'month'
}

export const psrData: MonitoringProps = {
  icons: [
    {
      icon: 'ShieldCheck',
      text: 'Securitas guard response'
    },
    {
      icon: 'SecureHome',
      text: 'Whole home monitoring'
    },
    {
      icon: 'PoliceCar',
      text: 'Police response'
    },
    {
      icon: 'Fire',
      text: 'Fire response'
    },
    {
      icon: 'CameraRecording',
      text: 'Unlimited video recordings'
    },
    {
      icon: 'PhoneRinging',
      text: 'Instant alarm alerts on your phone'
    },
    {
      icon: 'Discount',
      text: 'New hardware discount'
    },
    {
      icon: 'Contract',
      text: 'Premium Extended Warranty'
    }
  ],
  title: 'Pro Premium Monitoring',
  productSKU: 'SSEDSM2_GB__5229044',
  description: [
    '24/7 protection',
    'Unlimited camera recordings',
    'Security team act quickly in an emergency',
    'Police and fire brigade are alerted',
    '24/7 security guard dispatch'
  ],
  extraPriceText:
    'First 2 months are free, no contract, cancel any time. After trial, monitoring is charged separately for {{price_per_day}} ({{price_per_month}})**',
  monthSubtitle: 'months'
}
